const products = [
  {
    id: 1,
    name: "Sensi Advance Pack for Android",
    slug: "sensi-advance-pack-android",
    image: "/images/sensi-premium-android.jpg",
    price: 249,
    originalPrice: 499,
    description: `What will I get in advance sensi?

• Device booster ☠️  
• Advanced secret tips  
• Gameplay & device optimized sensi  
• No recoil UMP tips  
• Auto aim lock trick 🤫  
• Smooth device APK 🤫  
• Gloo wall tricks ✅☠️👾  
• Best HUDs 🥷  
• FPS boost ☠️✅  
• 90-95% headshot chance  
• Headshot method 💀  
• 100% gameplay improvement`
  },
  {
    id: 2,
    name: "Free Fire Red Fire Button Tutorial (iPhone)",
    slug: "free-fire-red-button-iphone",
    image: "/images/Free Fire red button for ios.jpg",
    price: 99,
    originalPrice: 199,
    description: "Learn how to set up and optimize the Red Fire Button for iPhones in Free Fire. This step-by-step video tutorial is specifically made for iPhone users to boost firing speed, reduce delay, and give you a tactical edge in close-range fights.",
  },
  {
    id: 3,
    name: "Best Sensitivity for iPhone (Free Fire MAX)",
    slug: "best-sensitivity-io-free-fire-max",
    image: "/images/sensi-classic-ios.jpg",
    price: 299,
    originalPrice: 499,
    description: `• Secret settings  
• Secret tips  
• Advanced sensitivity setup  
• Custom gameplay settings  
• Red Button tutorial ☠️✅  
• 90-95% Headshot Chance  
• Sensi is permanent`
  },
  {
    id: 4,
    name: "How to Fix Lag in Free Fire (Video Course)",
    slug: "lag-fix-free-fire-course",
    image: "/images/lag-fix.jpg",
    price: 50,
    originalPrice: 99,
    description: "Is lag ruining your game? This short and effective video guide helps you fix lag issues on Android & iOS. Covers system tweaks, in-game settings, and secret tricks to improve FPS and smooth gameplay — no root or third-party apps required.",
  },
  {
    id: 5,
    name: "Premium Sensi for Android",
    slug: "premium-sensi-for-android",
    image: "/images/premiumsensi.jpg",
    price: 149,
    originalPrice: 249,
    description: "Best sensitivity settings for smooth Android gameplay. Boosts FPS, improves aim, and reduces lag. Works on all major Android phones with no root required.",
  },
  { id:6,
    name:"NEW SENSI SHOTGUN METHOD",
    slug:"new-sensi-shotgun-method",
    image:"/images/NEW-SENSI-SHOTGUN-METHOD.jpg",
    price:135,
    originalPrice:200,
    description:"Discover the ultimate shotgun sensitivity settings for Free Fire with our exclusive video tutorial. Learn how to optimize your aim, reduce recoil, and increase your headshot rate using our proven methods. Perfect for players looking to dominate close-range combat and elevate their gameplay to the next level.",
  }
];

export default products;
